export default function DownloadSection() {
  return (
    <section id="download" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            选择你的设备，安全下载黄油相机
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            所有下载链接均来自官方渠道，确保安全无毒，请放心下载
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 text-center border border-background-200/70">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center bg-background-100 rounded-2xl">
              <i className="ri-apple-line text-3xl text-foreground-800"></i>
            </div>
            <h3 className="text-xl font-heading text-foreground-900 mb-2">iOS 版本下载</h3>
            <p className="text-sm text-foreground-500 mb-6">支持 iPhone / iPad，iOS 13.0 及以上</p>
            <a
              href="https://apps.apple.com/cn/app/id1042951887"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line"></i>
              App Store 下载
            </a>
            <p className="text-xs text-foreground-400 mt-4">版本 8.0 · 大小 156MB · 评分 4.8</p>
          </div>

          <div className="bg-background-50 rounded-2xl p-8 md:p-10 text-center border border-background-200/70">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center bg-background-100 rounded-2xl">
              <i className="ri-android-line text-3xl text-foreground-800"></i>
            </div>
            <h3 className="text-xl font-heading text-foreground-900 mb-2">Android 版本下载</h3>
            <p className="text-sm text-foreground-500 mb-6">支持各品牌安卓手机，Android 6.0 及以上</p>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-8 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line"></i>
              官网 APK 下载
            </a>
            <p className="text-xs text-foreground-400 mt-4">版本 8.0 · 大小 142MB · 兼容 Android 6.0+</p>
          </div>
        </div>

        <div className="mt-10 max-w-2xl mx-auto bg-background-50 rounded-xl p-5 border border-accent-200/70 flex items-start gap-3">
          <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-shield-check-line text-accent-500 text-xl"></i>
          </div>
          <div>
            <p className="text-sm text-foreground-700 font-medium mb-1">安全下载提示</p>
            <p className="text-xs text-foreground-500 leading-relaxed">
              请认准官方下载渠道。本站提供的下载链接均来自黄油相机官方，不含任何第三方广告或恶意代码。
              如在下载过程中遇到任何问题，请通过关于我们页面的联系方式与我们取得联系。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}